export const locationKeys = {
  locations: () => ['LOCATIONS'] as const,
  customer: (customerId: number | string) =>
    ['CUSTOMER_LOCATIONS', customerId] as const,
  details: (userId: number | string) => ['DETAILS', userId] as const,
};
